<template>
  <div class="home" ref="home" @scroll="handleScroll">
    <Header @home="someOtherMethod" />
    <!-- 轮播放图 -->
    <el-carousel :height="height" direction="horizontal" :autoplay="false" indicator-position="none">
      <el-carousel-item v-for="item in imgList" :key="item">
        <img :src="item" alt="" srcset="" width="100%" height="100%">
      </el-carousel-item>
    </el-carousel>
    <!-- 公司标语 -->
    <div>
      <el-row class="home-bg">
        <el-col :span="6" :offset="3">
          <div class="box-3">
            <div class="content-box">
              <img src="../assets/integrity.png" alt="信誉诚" width="70" height="70">
              <div>
                <h3>信誉诚</h3>
                <p>Credibility</p>
              </div>
            </div>
            <div class="font">诚</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="box-3 not-border">
            <div class="content-box">
              <img src="../assets/quality.png" alt="质量优" width="70" height="70">
              <div>
                <h3>质量优</h3>
                <p>Excellent quality</p>
              </div>
            </div>
            <div class="font">优</div>
          </div>
        </el-col>
        <el-col :span="6">
          <div class="box-3">
            <div class="content-box">
              <img src="../assets/cooperation.png" alt="服务佳" width="70" height="70">
              <div>
                <h3>服务佳</h3>
                <p>Good service</p>
              </div>
            </div>
            <div class="font">佳</div>
          </div>
        </el-col>
      </el-row>
    </div>
    <!-- 案例 -->
    <Case :winWidth="scrollValue" />
    <!-- 荣誉资质 font-size: 0;处理图片间隙 -->
    <div ref="certificate" style="font-size: 0;">
      <img src="../assets/images/certificate.png" alt="" srcset="" width="100%">
    </div>
    <About :winWidth="scrollValue" />
    <Footer />
  </div>
</template>

<script>

import Footer from '@/components/Footer.vue'
import About from '@/components/About.vue'
import Case from '@/components/Case.vue'
import Header from '@/components/Header.vue'

export default {
  name: 'HomeView',
  components: {
    Footer,
    About,
    Case,
    Header
  },
  data() {
    return {
      imgList: [
        require('../assets/c1.png'),
        require('../assets/c2.jpg'),
        require('../assets/c3.jpg'),
      ],
      height: '560px',
      windowWidth: 1440,
      scrollValue: {
        case: 800,
        honor: 1650,
        about: 2270
      }

    }
  },
  methods: {
    someOtherMethod(param) {
      const anchorElement = this.$refs[`${param}`];
      if (anchorElement) {
        // anchorElement.scrollIntoView({ behavior: 'smooth' });
        let c = 0;
        if (param == 'certificate') {
          console.log('certificate', this.windowWidth)
          c = this.scrollValue.honor;
        }
        window.scrollTo({
          top: c,
          behavior: 'smooth'
        });
      }
    },

    handleScroll(event) {
      console.log(event.target.scrollTop); // 输出滚动位置
    }
  },
  mounted() {
    let windowWidth = window.innerWidth;
    this.windowWidth = windowWidth

    if (windowWidth > 1920) {
      this.scrollValue = {
        case: 835,
        honor: 2026,
        about: 2912
      };
      this.height = '560px';
      console.log('荣誉资质大于1920', this.scrollValue)
    } else if (1600 < windowWidth && windowWidth <= 1920) {
      this.scrollValue = {
        case: 800,
        honor: 1940,
        about: 2800
      }
      console.log('荣誉资质-1920', this.scrollValue)
      this.height = '560px';
    } else if (1440 < windowWidth && windowWidth <= 1600) {
      this.scrollValue = {
        case: 825,
        honor: 1835,
        about: 2550
      }
      this.height = '475px';
      console.log('荣誉资质-1600', this.scrollValue, windowWidth)
    } else if (1200 < windowWidth && windowWidth <= 1440) {
      this.scrollValue = {
        case: 670,
        honor: 1650,
        about: 2270
      }
      this.height = '420px';
      console.log('荣誉资质-1440', this.scrollValue)
    }

    // this.height = windowWidth <= 1440 ? '420px' : '560px';
    window.addEventListener('scroll', function () {
      const scrollPosition = window.scrollY || document.documentElement.scrollTop;
      console.log('--', scrollPosition);
      // 处理滚动事件
    });
  },
  beforeDestroy() {
    // 移除事件监听
    window.removeEventListener('scroll', this.handleScroll);
  }
}
</script>


<style lang="scss" scoped>
// .home {
//   position: fixed;
//   top: 123px;
//   left: 0;
//   width: 100%;
//   height: 100vh;
//   overflow: scroll;
// }
.home {
  height: 100vh;
}

.home-bg {
  background: #ECECEC;
  height: 186px;
  overflow: hidden;
}

.not-border {
  border-left: none !important;
  border-right: none !important;
}

.box-3 {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-flow: row wrap;
  border-left: 1px solid #d2d2d2;
  border-right: 1px solid #d2d2d2;
  position: relative;
  height: 186px;

  .content-box {
    display: flex;
    align-items: center;

    div {
      margin-left: 30px;
      font-weight: 400;

      h1 {
        font-size: 24px;
        color: #2F2F2F;
      }

      p {
        font-size: 18px;
        color: #AD7F5A;
      }
    }
  }

  .font {
    width: 90px;
    height: 90px;
    font-weight: 600;
    font-size: 100px;
    color: #CFA886;
    opacity: 0.15;
    position: absolute;
    bottom: 20px;
    right: 17px;
    font-family: SimSun, Arial, sans-serif;
  }
}

@media (max-width: 1440px) {
  .font {

    font-size: 80px !important;
    bottom: 10px !important;
    right: 0px !important;
  }
}
</style>
